/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type GetKnowledgeDocuments200ItemStatus = typeof GetKnowledgeDocuments200ItemStatus[keyof typeof GetKnowledgeDocuments200ItemStatus];


export const GetKnowledgeDocuments200ItemStatus = {
  UPLOADING: 'UPLOADING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;
